import {
  ADD_ITEM_TO_CART_SUCCESS,
  ADD_ITEM_TO_CART_FAILURE,
  REMOVE_CART_SUCCESS,
  REMOVE_CART_ITEM_SUCCESS,
  UPDATE_CART_SUCCESS,
  REMOVE_CART_ITEM_FAILURE,
  UPDATE_CART_FAILURE,
  BULK_ADD_ITEM_TO_CART_SUCCESS,
  DOWNLOAD_CSV_SUCCESS,
  SHOW_ORDER_NOT_AVAILABLE,
  SHOW_BLOCKED_ACCOUNT_MODAL,
  REQUEST_QUOTE,
  REQUEST_QUOTE_SUCCESS,
  REQUISITION_SUBMIT_SUCCESS,
  REQUEST_QUOTE_CLICK,
  SHARE_CART_MODAL_ANALYTICS,
  SHARE_CART_SUBMIT_SUCCESS,
  SHARE_CART_SUBMIT,
} from '../../containers/templates/ShoppingCart/ShoppingCart.constants';

import {
  LOAD_CHECKOUT_USER_DATA_SUCCESS,
  LOAD_SOLD_TO_DETAILS_SUCCESS,
  ADD_ADDRESS,
  PLACE_ORDER,
  REVIEW_ORDER,
  ADD_CREDITCARD_SUCCESS,
  CART_TO_ORDER_ANALYTICS,
  QUOTE_TO_ORDER_ANALYTICS,
  CONTINUE_TO_PAYMENT,
} from '../../containers/templates/Checkout/Checkout.constants';

import {
  CREATE_QUOTE_SUCCESS,
  QUOTE_ANALYTICS_ON_LOAD,
} from '../../containers/templates/Quote/Quote.constants';

import {
  SET_GLOBAL_ERROR,
  LOAD_SHOPPING_CART_DATA_SUCCESS,
  GET_ORDER_SUMMARY_DATA_SUCCESS,
  CART_URL,
  QUICK_ORDER_URL,
  PLACE_ORDER_SUCCESS,
  QUOTE_ORDER_SUCCESS,
  SEARCH_BAR_SUBMIT,
  SEARCH_BAR_INTERACTION,
  LOAD_EMPTY_CART,
  PRODUCT_RECOMMENDATION,
  PRODUCT_RECOMMENDATION_TITLE,
  TRIGGER_ORDER_REVIEW_EVENT,
} from '../constants';

const trackingActions = [
  LOAD_SHOPPING_CART_DATA_SUCCESS,
  ADD_ITEM_TO_CART_SUCCESS,
  ADD_ITEM_TO_CART_FAILURE,
  REMOVE_CART_SUCCESS,
  REMOVE_CART_ITEM_SUCCESS,
  UPDATE_CART_SUCCESS,
  REMOVE_CART_ITEM_FAILURE,
  UPDATE_CART_FAILURE,
  SET_GLOBAL_ERROR,
  LOAD_CHECKOUT_USER_DATA_SUCCESS,
  LOAD_SOLD_TO_DETAILS_SUCCESS,
  ADD_ADDRESS,
  PLACE_ORDER,
  REVIEW_ORDER,
  GET_ORDER_SUMMARY_DATA_SUCCESS,
  BULK_ADD_ITEM_TO_CART_SUCCESS,
  PLACE_ORDER_SUCCESS,
  QUOTE_ORDER_SUCCESS,
  REQUEST_QUOTE,
  REQUEST_QUOTE_SUCCESS,
  DOWNLOAD_CSV_SUCCESS,
  SHOW_ORDER_NOT_AVAILABLE,
  SHOW_BLOCKED_ACCOUNT_MODAL,
  SEARCH_BAR_SUBMIT,
  ADD_CREDITCARD_SUCCESS,
  REQUISITION_SUBMIT_SUCCESS,
  REQUEST_QUOTE_CLICK,
  CREATE_QUOTE_SUCCESS,
  SHARE_CART_MODAL_ANALYTICS,
  SHARE_CART_SUBMIT_SUCCESS,
  SHARE_CART_SUBMIT,
  SEARCH_BAR_INTERACTION,
  CART_TO_ORDER_ANALYTICS,
  QUOTE_TO_ORDER_ANALYTICS,
  QUOTE_ANALYTICS_ON_LOAD,
  CONTINUE_TO_PAYMENT,
  LOAD_EMPTY_CART,
  PRODUCT_RECOMMENDATION,
  PRODUCT_RECOMMENDATION_TITLE,
  TRIGGER_ORDER_REVIEW_EVENT,
];

const storeToAnalyticsEventMap = {
  LOAD_SHOPPING_CART_DATA_SUCCESS: 'scView',
  ADD_ITEM_TO_CART_SUCCESS: 'scAdd',
  ADD_ITEM_TO_CART_FAILURE: 'scInvalidSku',
  REMOVE_CART_SUCCESS: 'scRemove',
  REMOVE_CART_ITEM_SUCCESS: 'scRemove',
  UPDATE_CART_SUCCESS: 'scUpdate',
  SET_GLOBAL_ERROR: 'scPageError',
  REMOVE_CART_ITEM_FAILURE: 'scCartError',
  UPDATE_CART_FAILURE: 'scCartError',
  LOAD_CHECKOUT_USER_DATA_SUCCESS: 'scShippingView',
  LOAD_SOLD_TO_DETAILS_SUCCESS: 'scSoldToDetails',
  ADD_ADDRESS_SHIPPING: 'scShippingAdd',
  ADD_ADDRESS_BILLING: 'scPaymentBillingAdd',
  CONTINUE_TO_PAYMENT: 'scPaymentButton',
  PLACE_ORDER_SHIPPING: 'scOrderSimulateCall',
  PLACE_ORDER_REVIEW: 'scPlaceOrderClick',
  GET_ORDER_SUMMARY_DATA_SUCCESS_ADD: 'scPromoCode',
  GET_ORDER_SUMMARY_DATA_SUCCESS_REMOVE: 'scPromoCodeRemove',
  BULK_ADD_ITEM_TO_CART_SUCCESS: 'scAdd',
  REVIEW_ORDER: 'scReviewOrder',
  PLACE_ORDER_SUCCESS: 'scOrderSuccess',
  QUOTE_ORDER_SUCCESS: 'scOrderSuccess',
  PLACE_ORDER_SUCCESS_SIMULATE: 'scOrderSimulateSuccess',
  QUOTE_ORDER_SUCCESS_SIMULATE: 'scOrderSimulateSuccess',
  REQUEST_QUOTE: 'scRequestAQuote',
  REQUEST_QUOTE_SUCCESS: 'scRequestQuoteSuccess',
  DOWNLOAD_CSV_SUCCESS: 'scDownloadCart',
  SHOW_ORDER_NOT_AVAILABLE: 'scNotAvail',
  SHOW_BLOCKED_ACCOUNT_MODAL: 'scAcctRestrict',
  SEARCH_BAR_SUBMIT: 'eProcSearch',
  ADD_CREDITCARD_SUCCESS: 'scPaymentCreditCard',
  REQUISITION_SUBMIT_SUCCESS: 'eProcRequisition',
  REQUEST_QUOTE_CLICK: 'scRequestAQuoteClick',
  CREATE_QUOTE_SUCCESS: 'scRequestAQuote',
  SHARE_CART_MODAL_ANALYTICS: 'scShareCartClick',
  SHARE_CART_SUBMIT_SUCCESS: 'scShareCartSuccess',
  SHARE_CART_SUBMIT: 'scShareCartSubmit',
  SEARCH_BAR_INTERACTION: 'searchInteraction',
  CART_TO_ORDER_ANALYTICS: 'scCartCheckedOut',
  QUOTE_TO_ORDER_ANALYTICS: 'scQuoteCheckedOut',
  QUOTE_ANALYTICS_ON_LOAD: 'scCreateQuoteLoad',
  LOAD_EMPTY_CART: 'scView',
  PRODUCT_RECOMMENDATION: 'at_product_rec_impression',
  PRODUCT_RECOMMENDATION_TITLE: 'at_product_rec_click',
  TRIGGER_ORDER_REVIEW_EVENT: 'scReviewOrderLoad',
};

// Add Item context value for Analytics
const cartContext = {
  [CART_URL]: 'Cart: Quick Add',
  [QUICK_ORDER_URL]: 'Cart: Quick Add',
  bulkUploadQuickOrder: 'Cart: Quick Add-multi',
};

// Checkout Section page names
const SHIPPING_SECTION = 'Checkout-Shipping';
const PAYMENT_SECTION = 'Checkout-Payment';
const REVIEW_SECTION = 'Checkout-Review';

const skipAnalyticsLogging = [LOAD_SHOPPING_CART_DATA_SUCCESS];

export default trackingActions;
export {
  storeToAnalyticsEventMap,
  skipAnalyticsLogging,
  cartContext,
  SHIPPING_SECTION,
  PAYMENT_SECTION,
  REVIEW_SECTION,
};
